import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import AccountInfo from "../AccountInfo";

import { ReactComponent as OrganizationIcon } from "assets/images/icon_organization.svg";
import { ReactComponent as ExpandIcon } from "assets/images/expand-icon.svg";

import { IbanInvoiceResponseDto } from "api";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

interface AccountInfoCollapsibleProps {
  iban: IbanInvoiceResponseDto | null;
  isPreview?: boolean;
}

const AccountInfoCollapsible: React.FC<AccountInfoCollapsibleProps> = (
  props,
) => {
  const { iban, isPreview } = props;

  const [isOpen, setIsOpen] = React.useState(false);

  const defaultOrgName = "Юридична назва компанії або ФОП";
  const defaultSubtitle = isOpen
    ? "Приховати деталі оплати"
    : "Показати деталі оплати";

  const onToggle = () => {
    !isPreview &&
      analytics().sendConversionEvent(
        isOpen
          ? AnalyticsEvents.iban_qr_close_acc_info
          : AnalyticsEvents.iban_qr_open_acc_info,
        null,
        true,
      );

    setIsOpen(!isOpen);
  };

  return (
    <Paper sx={{ width: "360px", p: "0 !important" }}>
      <Stack
        data-testid="account-info-collapsible"
        direction="row"
        gap={1.5}
        alignItems="center"
        onClick={onToggle}
        sx={{ cursor: "pointer", p: 1.5 }}
      >
        <OrganizationIcon style={{ flexShrink: 0 }} />
        <Stack direction="column" gap={0.5} overflow="hidden">
          <Typography noWrap variant="body2">
            {iban?.publicName?.trim() ||
              iban?.organizationName.trim() ||
              defaultOrgName}
          </Typography>
          <Typography noWrap variant="subtitle2" color="grey700">
            {defaultSubtitle}
          </Typography>
        </Stack>

        <IconButton sx={{ marginLeft: "auto" }}>
          {isOpen ? (
            <ExpandIcon style={{ transform: "rotate(180deg)" }} />
          ) : (
            <ExpandIcon />
          )}
        </IconButton>
      </Stack>

      <Collapse in={isOpen}>
        <Box sx={{ p: 1.5 }}>
          <AccountInfo iban={iban} copyEnabled={!isPreview} />
        </Box>
      </Collapse>
    </Paper>
  );
};

export default AccountInfoCollapsible;
